import { IPortalUserRoleEnum } from 'Modules/Communication/PortalUsers/shared/models/PortalUsers'
import { IAddress } from 'shared/models/Adress'
import { IFilterModel } from 'shared/models/List'
import { IUnitIdentificationFields } from 'shared/models/Unit'

export interface IResidentContact {
  email: string
  mobile: string
  name: string
  nameregisterId: string
  reservedAgainstElectronicCommunication: string
  hasSignedIn: boolean

  role?: IPortalUserRoleEnum
  roleDescription?: string

  unitInfo?: {
    address: string
    addressId?: number
    buildingTypeIndexNo?: number
    buildingType: string
    unitIdentification: IUnitIdentificationFields
    unitId: string
  }[]
}

export interface IBoardContact {
  id: number
  fullname: string
  lastname: string
  firstname: string
  email: string
  phone: string
  fax: string
  zipCode: string
  city: string
  adressline1: string
  adressline2: string
  adressline3: string
  notes: string
  companyName: string
  department: string
  position: string
  mobile: string
  webAdress: string
  organizationNumber: string
  isCompany: boolean
  countryCode: string
}

export interface IManageBoardContact {
  isCompany: boolean
  firstname: string
  lastname: string
  phone: string
  mobile: string
  email: string
  webAdress: string
  companyName: string
  organizationNumber: string
  position: string
  department: string
  notes: string
  adressline1: string
  adressline2: string
  adressline3: string
  zipCode: string
  city: string
  countryCode: string
}

export interface IOtherContact {
  nameregisterId: string
  companyName: string
  position: string
  name: string
  email: string
  mobile: string
  workPhoneNumber: string
  workEmail: string
  address: IAddress
}

export interface IContactFilters extends IFilterModel {
  contactRole: ContactsScopeEnum
  extendedQueryType?: ExtendedQueryTypeEnum
  addressId?: number
  buildingTypeId?: number
  boardId?: string
  buildingId?: number
}

export enum ExtendedQueryTypeEnum {
  EmailContacts,
  SmsContacts,
}

export enum ContactsScopeEnum {
  Owners = 'Owner',
  Tenants = 'Tenant',
  Cohabitant = 'CoResident',
}

export enum ContactsSectionEnum {
  Owners = 'eiere',
  Cohabitant = 'medboende',
  Tenants = 'leietakere',
  Others = 'andrekontakter',
  BoardContacts = 'styretskontakter',
}

export enum ResidentContactsSortFieldEnum {
  Name = 'Name',
  Mobile = 'Mobile',
  Email = 'Email',
  Reserved = 'ReservedAgainstElectronicCommunication',
}

export enum OtherContactsSortFieldEnum {
  Name = 'Name',
  CompanyName = 'CompanyName',
  Position = 'Position',
  Email = 'Email',
  Mobile = 'Mobile',
  WorkPhoneNumber = 'WorkPhoneNumber',
  WorkEmail = 'WorkEmail',
}

export enum BoardContactsSortFieldEnum {
  Name = 'FirstName',
  // LastName,
  CompanyName = 'CompanyName',
  Email = 'Email',
  Mobile = 'Mobile',
  Phone = 'Phone',
  Position = 'Position',
}
